import * as React from "react";
import jfetch from "../../utils/jfetch";
import {useState,useEffect} from "react";
import Button from "../core/Button"
import axios from "axios"
import confetti from "canvas-confetti"

function RegisterButton(props:any){
  const [show, setShow] = useState(false)
  const [registered, setRegistered] = useState(null)
  const [url, setUrl] = useState('#academy')
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState('0')
  const [makeTicket, setMakeTicket] = useState(false)


  const count = 200;
  const defaults = {
    origin: { y: 0.7 }
  };
  function fire(particleRatio, opts) {
    confetti(Object.assign({}, defaults, opts, {
      particleCount: Math.floor(count * particleRatio)
    }));
  }

  function run_da_confetti(){
    fire(0.25, {
      spread: 26,
      startVelocity: 55,
    });
    fire(0.2, {
      spread: 60,
    });
    fire(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8
    });
    fire(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2
    });
    fire(0.1, {
      spread: 120,
      startVelocity: 45,
    });
  }
  

  useEffect(() => {
    // make jfetch to show if we are showing button or nahh 
    jfetch.get('/global_settings/show').then((resp) => {
      if(resp.setting.register_homepage != null){
        setShow(resp.setting.register_homepage)
      }
      if(resp.setting.register_url != null){
        setUrl(resp.setting.register_url)
      }
      if(resp.setting.list_id != null){
        setList(resp.setting.list_id)
      }
      if(resp.setting.academy_tickets != null){
        setMakeTicket(resp.setting.academy_tickets)
      }
    })

    // make a fetch to check if registered 
    jfetch.get('/ac/contacts/check', {email: props.currentUser.email})
    .then((resp) => {
      setRegistered(resp.registered)
    })
    
  }, [])

  // on click make a fetch request to register
  async function register_user(){
    setLoading(true)

    let reg_resp = await axios.post(
      'https://api.chartec.net/v2/academy/register/quick?id=asd6yb5i465l339j0s0j033ksdiwDaaa', 
      {email: props.currentUser.email},
      {headers:{'Content-Type':'application/json', 'Accept':'*/*'}}
    )
    
    if(reg_resp.data[0] == "true"){
      setLoading(false)
      setRegistered(true)
      run_da_confetti()
     await jfetch.post('/registrations', {registration:{list_id:+list, user_id:props.currentUser.id}})
     await create_ticket(props.currentUser.name, props.orgName, today_date())
    }

    // axios
    // .post(
    //   'https://api.chartec.net/v2/academy/register/quick?id=asd6yb5i465l339j0s0j033ksdiwDaaa', 
    //   {email: props.currentUser.email},
    //   {headers:{'Content-Type':'application/json', 'Accept':'*/*'}}
    // )
    // .then((resp) => {
    //   if(resp.data[0] == "true"){
    //     setLoading(false)
    //     setRegistered(true)
    //     run_da_confetti()
    //     jfetch.post('/registrations', {registration:{list_id:+list, user_id:props.currentUser.id}})
    //   }
    // })
  }

  async function create_ticket(user_name, org_name, when){
    //let make =  makeTicket && (props.pgId == 1)
    if(makeTicket){
      const params = {
        companyid: "CharTec",
        subject: `Core User registered for Academy`,
        message: `a Core User registred for academy:
                  \n ${user_name} from ${org_name} registered for academy via core on ${when}`,
        board: "marketing",
        recid: 2
      };
      return await jfetch.post('/api/ct_cw/create_ticket', params);
    }
  }

  function today_date(){
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let r = mm + '/' + dd + '/' + yyyy;

    return r
  }


  const myDisplay = (show && registered != null) ? 'initial' : 'none'

  return(
    
    <div className="chat-bar" style={{width : "80%", float: "left", paddingTop:'15px', paddingLeft:'30px', display:myDisplay}}>
      { registered ? 
      <span style={{marginRight:'15px'}}>
        <strong>
          Congrats!
          <span style={{padding:'0px 5px'}}>
            <i className="fa fa-thumbs-o-up" style={{color:'#2196f3'}}/>
            </span>
          You are registered for <a href={url} target="_blank" rel="noopener noreferrer">Academy</a>!
        </strong>
      </span>
      :       
      <>
      <span style={{marginRight:'15px'}}>
        <strong>
          <a href={url} target="_blank" rel="noopener noreferrer">Academy</a> {props.message}
        </strong>
      </span>
      {/* <Button color="info" loading={loading} onClick={register_user}>Register Now!</Button> */}
      {/* Changed to External link per brandis request */}
      <a className="btn btn-info" href="https://marketingchartec.activehosted.com/f/178" target="_blank" rel="noopener noreferrer">
        Register Now!
      </a>
      </>
      }
    </div>
  )
}


export default RegisterButton;


// WEBPACK FOOTER //
// ./app/javascript/components/preloaded/RegisterButton.tsx